import { withStyles } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  infoOutlinedIconStyle: {
    paddingLeft: 7,
    verticalAlign: 'bottom',
    fontStyle: 'italic'
  }
});
const EquipmentUpdateWarning = ({ classes, equipmentType }) => {
  return (
    <div className={classes.container}>
      <InfoOutlinedIcon />
      <span className={classes.infoOutlinedIconStyle}>{`Please note that selecting ${
        equipmentType === 'Fixed' ? 'fixed' : 'max/min'
      } equipment limits optimization results, so use it only when necessary.`}</span>
    </div>
  );
};

export default withStyles(styles)(EquipmentUpdateWarning);
